import React, { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { faScreenUsers } from '@fortawesome/pro-light-svg-icons'

import { useHistory } from 'react-router'
import { FaIcon } from '../../App/Components'
import { useLocation, useParams } from '../../Router'
import { useAppSelector } from '../../store/hooks'
import { WorkshopListView } from '../WorkshopListView/WorkshopListView'
import {
  IconTileContainer,
  IconTileIconContainer,
  IconTileText,
} from '../../App/Components/IconTile/style'

type Props = {
  display: 'tile' | 'list'
}

const tileLinkStyle = {
  appearance: 'none' as const,
  background: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  textDecoration: 'none' as const,
  color: 'inherit',
  display: 'block' as const,
}

export const WorkshopItem = ({ display }: Props) => {
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation()
  const { establishmentId } = useParams<{ [key: string]: string }>()

  const workshops = useAppSelector((state) => state.workshops.list)
  const settings = useAppSelector((state) => state.settings.values)

  const currentPath = location.pathname.replace(/\/+$/, '')
  const isRootPath: boolean =
    currentPath === `/${establishmentId}/menu` ||
    currentPath === `/${establishmentId}/activities`

  const showItem: boolean =
    typeof workshops !== 'undefined' && workshops.length > 0 && isRootPath

  if (!showItem) {
    return null
  }

  /*
   * OB-506: absolute path so the URL is portable when copied via
   * right-click "Copy Link Address" / long-press "Copy link".
   */
  const workshopsUrl = `/${location.pathname.split('/')[1]}/workshops`

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.altKey ||
      e.ctrlKey ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    history.push(workshopsUrl)
  }

  if (display === 'list') {
    return (
      <WorkshopListView
        title={t('Workshops')}
        image="//files.optios.net/?id=1392347"
      />
    )
  }

  return (
    <IconTileContainer>
      <a href={workshopsUrl} onClick={handleClick} style={tileLinkStyle}>
        <IconTileIconContainer highlightcolor={settings.highlightColor}>
          <FaIcon
            size="3x"
            icon={faScreenUsers}
            color={settings.highlightColor}
          />
        </IconTileIconContainer>
        <IconTileText>{t('Workshops')}</IconTileText>
      </a>
    </IconTileContainer>
  )
}
